const nodeCount = 12;
// Four laps of smoothly varying intervals keep the chase from feeling metronomic.
const intervals = Array.from(
  { length: nodeCount * 4 },
  (_, step) =>
    0.29 + 0.13 * Math.sin(step * 0.73) + 0.065 * Math.sin(step * 1.91 + 0.8),
);
const duration = intervals.reduce((total, interval) => total + interval, 0);
const pulses: string[][] = Array.from({ length: nodeCount }, () => []);
const travel = ["0"];
let elapsed = 0;
for (const [step, interval] of intervals.entries()) {
  const percent = (time: number) => `${((100 * time) / duration).toFixed(4)}%`;
  pulses[step % nodeCount].push(
    `0 ${percent(elapsed)}`,
    `1 ${percent(elapsed + interval * 0.35)}`,
    `0 ${percent(elapsed + interval)}`,
  );
  elapsed += interval;
  travel.push(
    `${((step + 1) / intervals.length).toFixed(6)} ${percent(elapsed)}`,
  );
}
const points = pulses.map((pulse, index) => {
  const angle = (index * Math.PI * 2) / nodeCount - Math.PI / 2;
  return {
    x: 12 + 6.4 * Math.cos(angle),
    y: 12 + 6.4 * Math.sin(angle),
    timing: `linear(0, ${pulse.join(", ")}, 0)`,
  };
});
const path = `path("M${points.map(({ x, y }) => `${x},${y}`).join(" L")} Z")`;

export function LoadingGeometry({ animated }: { animated: boolean }) {
  return (
    <svg
      className="loading-ring"
      style={{ width: "1em", height: "1em", animationDuration: `${duration}s` }}
      viewBox="0 0 24 24"
      data-animated={animated ? "true" : undefined}
    >
      {points.map(({ x, y, timing }, index) => {
        const next = points[(index + 1) % points.length];
        return (
          <g key={index} style={{ animationTimingFunction: timing }}>
            <line
              className="loading-edge"
              x1={x}
              y1={y}
              x2={next.x}
              y2={next.y}
            />
            <circle className="loading-node" cx={x} cy={y} r="0.6" />
          </g>
        );
      })}
      <circle
        className="loading-packet"
        r="0.9"
        style={{
          offsetPath: path,
          animationTimingFunction: `linear(${travel.join(", ")})`,
        }}
      />
    </svg>
  );
}
